import Cookies from 'js-cookie';

import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static values = {
    show: {
      type: Boolean,
      default: false,
    },
  };

  connect() {
    if (!Cookies.get('cookiesStatus')) {
      this.show();
    }
  }

  showValueChanged() {
    if (this.showValue) {
      this.show();
    } else {
      this.hide();
    }
  }

  accept() {
    Cookies.set('cookiesStatus', 'accepted');
    this.hide();
  }

  decline() {
    Cookies.set('cookiesStatus', 'declined');
    this.hide();
  }

  show() {
    this.element.classList.remove('hidden');
  }

  hide() {
    this.element.classList.add('hidden');
  }
}
